function idProgress(list) {
  if (!list?.length) return '';
  let key = '';
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    key += `${item?.id || ''}:${item?.name || ''}:${item?.color || ''}:${item?.progress ?? ''}|`;
  }
  return key;
}

/** Visual inputs shared by every card. A new mission does not change this. */
export function boardChromeKey(flow) {
  const tags = flow?.allTags?.length ? flow.allTags : (flow?.allCategories || []);
  return [
    flow?.campaignId || '',
    flow?.isTemplate ? 1 : 0,
    flow?.currentView || '',
    flow?.activeCustomViewId || '',
    idProgress(tags),
    idProgress(flow?.statuses),
    idProgress(flow?.nestedSprints),
    idProgress(flow?.customFields),
  ].join('~');
}

export function sameLock(a, b) {
  if (a === b) return true;
  const left = a || {};
  const right = b || {};
  const leftBlocks = (left.blockingTasks || []).map((item) => item?.id || item).join(',');
  const rightBlocks = (right.blockingTasks || []).map((item) => item?.id || item).join(',');
  return !!left.isLocked === !!right.isLocked
    && !!left.isExcluded === !!right.isExcluded
    && (left.lockReason || '') === (right.lockReason || '')
    && (left.parentMissionName || '') === (right.parentMissionName || '')
    && (left.parentCampaignName || '') === (right.parentCampaignName || '')
    && leftBlocks === rightBlocks;
}

/** True when the next list is the previous list plus new items at the end. */
export function appendedOnly(prevTasks, nextTasks) {
  if (prevTasks === nextTasks) return true;
  if (!prevTasks && !nextTasks) return true;
  if (!prevTasks || !nextTasks || nextTasks.length < prevTasks.length) return false;
  for (let i = 0; i < prevTasks.length; i += 1) {
    if (prevTasks[i] !== nextTasks[i]) return false;
  }
  return true;
}
